import { AudioLines } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface VoiceConversationToggleProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  /** Hide when browser doesn't support Web Speech API. */
  isSupported: boolean;
}

export function VoiceConversationToggle({
  enabled,
  onToggle,
  isSupported,
}: VoiceConversationToggleProps) {
  const { t } = useTranslation('common');

  if (!isSupported) return null;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={() => onToggle(!enabled)}
      aria-label={
        enabled
          ? (t('voice_conversation_off', 'Desactiver conversation vocale') as string)
          : (t('voice_conversation_on', 'Activer conversation vocale') as string)
      }
      aria-pressed={enabled}
      className={cn(
        'shrink-0 size-8',
        enabled &&
          'bg-red-50 text-red-500 hover:bg-red-100 hover:text-red-600 dark:bg-red-950 dark:hover:bg-red-900',
      )}
    >
      <AudioLines className="size-4" />
    </Button>
  );
}
